import '../global';
class Rspns {
    constructor(body, init) {
        if (!new.target) {
            throw new TypeError(`Class constructor 'Response' cannot be invoked without 'new'`);
        }
        return new Response(body, init);
    }
}
const klass = Rspns;
export {
    klass as Response
};
export default klass;    //# sourceMappingURL=Response.js.map
